export const PRIMARY_JWT_INDEX = 0;

export const jwtTokenIntlRoot = 'jwt-token';

export const MINIMAL_TOKENS_LIMIT = 1;
